// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 24 24\"><path fill=\"%23ffffff\" d=\"M7 10l5 5 5-5z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trading-external .main-container-trading {
  display: flex; /* Flexbox for layout */
  flex-wrap: wrap; /* Allow content to wrap on smaller screens */
  width: 100vw; /* Full width of the viewport */
  box-sizing: border-box; /* Include padding in width calculations */
  min-height: 100vh; /* Ensure it takes full height of the viewport */
  margin: 0; /* Remove margin to take full width */
  background: rgba(32, 35, 66, 1);
}

.trading-external {
  background-color: rgb(32, 35, 66);
  margin-top: -40px;
  margin-bottom: -5px;
  height: calc(100% + 45px);
  width: 100%;
}

.trading-external .Heading-v {
  padding: 0 20px;
  margin-top: 50px;
}


.trading-external .heading {
  color: white;
  font-size: 20px;
  max-height: 10px;
  font-family: Graphik;
  font-size: 18px;
  font-weight: 600;
  line-height: 18.4px;
  letter-spacing: 0.13803686201572418px;
  margin-left: 20px;
}

.trading-external .line-height {
  border-bottom: 1px solid #7898de;
}

.trading-external .trading-dropdowns {
  border-style: solid;
  border-radius: 10px;
  /* width: 250px; */
  font-size: 14px;
  font-weight: 400;
  padding-left: 15px;
  border-width: 1px;
  background-color: #101222;
  color: #ffffffde;
  border: 1px solid #424750; /* Remove default dropdown arrow in Webkit browsers */ /* Remove default dropdown arrow in Firefox */
  appearance: none; /* Remove default dropdown arrow in other browsers */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Custom dropdown icon */
  background-repeat: no-repeat;
  background-position: right 10px center; /* Position the custom icon */
  background-size: 30px; /* Size of the custom icon */
}

.filter-icon-setting {
  border-style: solid;
  border-radius: 10px;
  width: 250px;
  font-size: 14px;
  font-weight: 400;
  padding-left: 15px;
  padding-right: 30px; /* Space for custom icon */
  border-width: 1px;
  background-color: #101222;
  color: #ffffffde;
  border: 1px solid #424750; /* Remove default dropdown arrow in Webkit browsers */ /* Remove default dropdown arrow in Firefox */
  appearance: none; /* Remove default dropdown arrow in other browsers */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Custom dropdown icon */
  background-repeat: no-repeat;
  background-position: right 40px center; /* Position the custom icon */
  background-size: 30px; /* Size of the custom icon */
}

.setting-button {
  background-color: transparent; /* Removes default button background */
  border: none; /* Removes button border */
  cursor: pointer; /* Shows pointer cursor on hover */
  padding: 5px; /* Optional: Adds some padding around the icon */
  margin-left: -50px;
  margin-right: 20px;
}
.line-section-major {
  border-bottom: 1px solid #5A596C;
  margin: 0 20px;
}


.trading-external .dropdown-container {
  margin: 10px 0;
  display: flex !important;
  justify-content: space-between;
}

.trading-external .dropdown-heading {
  font-family: Graphik;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #ffffffde;
  margin: 10px 20px;
  display: flex;
    align-items: center;
}

.trading-external .icons {
  margin: 0px 15px;
}

.trading-external .dropdown-container-2 {
  margin: 15px 20px;
  display: flex !important;
  align-items: stretch;
  height: calc(100vh - 200px);
}

.trading-external .box1 {
  height: 49%;
  border-radius: 10px;
  background-color: #101222;
}

.trading-external .sub-box-1 {
  /* background: #19233880 !important; */
  /* background: linear-gradient(#19233880 50%) !important; */
  background-color: rgba(25, 35, 56, 0.5);
  border-radius: 15px;
  height: 49%;
  margin-top: 10px;
  overflow-y: scroll;
}

.trading-external .mainbox1 {
  margin: 10px;
  width: 30%;
  /* height: 500px; */
  border-radius: 15px;
}

.external-browse-button,
.trading-external .upload-button-trade {
  border-radius: 9.111px;
  border: 0.911px solid #9A60FF;
  background: #2A2753;
  box-shadow: 0px 18.221px 36.443px 0px rgba(154, 96, 255, 0.25);
  display: flex;
  width: auto;
  height: 39px;
  padding: 0px 23.336px 0px 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-top: 10px;
  cursor: pointer;
}

.trading-external .box2 {
  width: 70%;
  max-width: 100%;
  /* height: 500px; */
  background-color: #101222;
  margin: 10px auto;
  border-radius: 10px;
  color: white;
  /* padding: 3%; */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-x: auto; /* Ensures that child elements do not overflow the container */
}

.trading-external .no-data-show {
  display: flex;
  justify-content: center; /* Horizontally center content */
  align-items: center;     /* Vertically center content */
  flex-direction: column;  /* Stack image and text vertically */
  height: 100%;
}

.trading-external .no-data-show img {
  width: 340px;   /* Set the image width */
  height: 200px;  /* Set the image height */
  object-fit: contain;  /* Keep the aspect ratio of the image, avoiding distortion */
}

.trading-external .text-inside-no-data {
  margin-top: 10px; /* Add some space between the image and the text */
  text-align: center; /* Center the text */
}

.trading-external .json-box-margin {
  flex-grow: 1;                 /* Allow the box to grow to fill available space */
  overflow-y: auto;             /* Enable vertical scrolling */
  overflow-x: hidden;           /* Hide horizontal scrolling */
  background-color: #282244;
  padding: 10px;
  border-radius: 5px;
  margin: 2px;
  max-width: 100%;
  box-sizing: border-box;
  max-height: 100%;
}

.trading-external .browse-files-containers {
  border: 2px dashed #424750;
  background-color: #101222;
  margin-right: 25px;
  color: white;
  text-align: center;
  height: 100%;
  width: 100%;
  align-content: center;
}

.trading-external .Placeholder1 {
  color: #FFF;
text-align: center;
font-family: Graphik;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
}

.trading-external .Placeholder2 {
  color: #A9ACB4;
  text-align: center;
  font-family: Graphik;
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 5px;
}

.trading-external .Placeholder-3 {
  font-family: "Graphik", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: white;
  line-height: 15px;
} 

.trading-external .Placeholder-4 {
  font-family: "Graphik", sans-serif;
  font-size: 10px;
  font-weight: 400;
  color: #a9acb4;
}

.trading-external .browse-text {
  margin-top: 5px;
  text-align: center;
}

.trading-external .browse-logo {
  width: 25px;
  height: 50px;
}

.regenrate-trading-button {
  margin: 0px; /* Margin for spacing around button */
}

.trading-external .upload-button:disabled {
  opacity: 0.6; /* Set a visible opacity for disabled state */
  cursor: not-allowed;
  background-color: #4a4a4a; /* A grey background for disabled state */
}

.trading-external .upload-button-section {
  display: flex; /* Use Flexbox for centering */
  justify-content: center; /* Center the text horizontally */
  align-items: center; /* Center the text vertically */
}

.trading-external .upload-btn-label,
.regenrate-button-label {
  font-family: "Graphik", sans-serif;
  font-size: 12px; /* Use a consistent font size */
  font-weight: 500;
  color: #ffffff; /* White text color */
  line-height: 1rem; /* Adjusted line-height for readability */
  margin: 0; /* Removed margins to allow Flexbox to handle centering */
  text-align: center; /* Ensure text is centered */
}

.trading-external .template-dropdown {
  border-radius: 10px;
  margin: 0px 10px;
}

.trading-external .tab-spacing {
  margin: 0 15px 15px;
}

.trading-external .settingIcon {
  background-color: #101222;
  margin: 0px !important;
  height: 54px;
  width: 54px;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
}


.templateHeading {
  width: 90%;
  height: 50px;
  color: #ffffff;
  border-radius: 10px;
  align-items: center;
  margin: 15px;
  align-content: center;
  background: #2a2753;
}

.borderType-selected {
  border: 1px solid #9a60ff !important;
}

.divSection {
  /* display:flex; */
  justify-content: center;
}

.sectionHeading {
  color: #ffffffde;
  margin: 5px ;
}

.sectionHeading-first {
  margin: 10px 0px 0px 15px;
}

.checkBox {
  color: #9a60ff;
  margin: 0px 5px;
}

.displayProperty {
  margin-right: 5px;
}

.hideInputBox {
  display: none;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 15px;
  overflow-y: scroll;
  height: 350px;
}

.flex-item {
  flex-basis: calc(50% - 30px); /* Two columns with gap */
  color: #ffffff;
  background: #2a2753;
  border-radius: 10px;
  height: 70px;
  margin-left: 15px;
  align-content: center;
  border: 1px solid #ffffff;
  overflow-y: scroll;
}

.add-button {
  border: 0.75px solid #FFFFFFDE;
  background: #101222;
  color: #a9acb4;
  border-radius: 37px;
  float: right;
  width: 68px;
  font-size: 12px;
}

.form-inputs {
  border-radius: 5px;
  margin-top: 8px;
  font-size: 14px;
  font-style: italic;
  width: 390px;
  height: 35px;
}

.form-submit {
  border-radius: 9px;
  width: 115px;
  height: 41px;
  background: #2A2753;
  border: 0.91px solid #9A60FF;
  float: right;
  margin: 10px 5px;
  color: #FFFFFF;
}

.save-cancel-button {
  border: 0.75px solid #FFFFFFDE;
  color: #ffffff;
  float: right;
  width: 115px;
  height: 41px;
  border-radius: 9.69px;
  background: #2A2753;
  margin-top: 30px;
}

.save-button {
  margin-right: 5%;
}

.cancel-button {
  /* background: #A100FF33; */
  margin-right: 1%;
  box-shadow: 0px 3px 20px 0px #A100FF33;
}

.add-icon {
  width: 10px;
  height: 10px;
  margin: 0px 3px 2px 0px;
}


.status-heading {
  font-size: 16px;
  border-bottom: 1px solid white;
}

.status-placeholder {
  margin-bottom: 0px !important;
  align-items: flex-start;
  display: flex;
}

.loader-box {
  background-color:  rgba(61, 31, 115, 1);
}

.loader-block {
  /* width: 380px; */
  height: 50px;
  color: #ffffff;
  border-radius: 6px;
  align-items: center;
  align-content: center;
  background: rgba(61, 31, 115, 1);
  padding: 9px;
}

.heading-trading {
  padding: 30px 0px 0px 10px !important;
}

.heading-genai-trading {
  margin-top: 15px !important;
}

.icon-text {
  color: #ffffff;
  margin: 0px 10px !important;
  align-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  font-family: "Graphik", sans-serif;
}

.icon-disabled {
  color: #a9acb4 !important;
}


.file-details {
  display: flex;
  align-items: center;
  margin-left: 10px;
  padding: 0px 16px;
  border-radius: 16px;
  background: #FFFFFF;
  color: #363636;
  margin: auto;
  width: fit-content;
}

.file-details span {
  margin-right: 10px;
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 500;
  line-height: 14.06px;
  text-align: center;
}

.remove-file-button {
  background: #FFFFFF;
  border: none;
  color: #24232B;
  font-size: 20px;
  cursor: pointer;
}

.remove-file-button span {
  display: flex;
  width: 7.52px;
  padding: 4px 0px;
}

.trading-tab {
  display: flex;
  justify-content: space-between;
  align-content: center;

  .left-button-allign {
    margin-right: 30px;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  
  .tab-container {
    display: flex;
    border-bottom: 2px solid #ccc;
    margin-bottom: 10px;
  }
  
  .tab-button, .active-tab-button {
    cursor: pointer;
    background-color: #101222;
    color: white;
    border: none;
    outline: none;
    transition: background-color 0.3s ease;
    font-size: 12px;
    display: flex;
    gap: 8px; /* Space between image and text */
    padding-top: 10px;
  }
  
  .active-tab-button {
    border-bottom: 3px solid #6739B7; /* Highlight the active tab */
  }
  
  /* Optional: Add hover effects for better UX */
  .tab-button:hover, .active-tab-button:hover {
    background-color: #1a1c34; /* Slightly lighter background on hover */
  }
  
 
  
  

  .tab-content {
    padding: 10px;
    background-color: #555;
    color: white;
    border-radius: 5px;
    display: flex;          /* Flex layout for the tab content */
    flex-direction: column; /* Column direction so content stacks vertically */
    height: 100%;           /* Make it take full available height */
    max-height: 100%; 
    margin: 0 15px 15px;
  }
  
  .xml-content {
    white-space: pre-wrap;
    color: white;
    background-color: #333;
    padding: 10px;
    border-radius: 5px;
  }
  
}
.trading-external .stop-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 84px;
  height: 39px;
  gap: 11px;
  border-radius: 9px;
  border: 1px solid #FF6063;
  cursor: pointer;
  background-color: #532731;
  margin: 10px;
  box-shadow: 0px 12px 16px -16px #022B4940;
}

`, "",{"version":3,"sources":["webpack://./src/Trading/Trading.css"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAE,uBAAuB;EACtC,eAAe,EAAE,6CAA6C;EAC9D,YAAY,EAAE,+BAA+B;EAC7C,sBAAsB,EAAE,0CAA0C;EAClE,iBAAiB,EAAE,gDAAgD;EACnE,SAAS,EAAE,qCAAqC;EAChD,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB,EACC,qDAAqD,EACxD,6CAA6C;EACpE,gBAAgB,EAAE,oDAAoD;EACtE,yDAAqL,EAAE,yBAAyB;EAChN,4BAA4B;EAC5B,sCAAsC,EAAE,6BAA6B;EACrE,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB,EACC,qDAAqD,EACxD,6CAA6C;EACpE,gBAAgB,EAAE,oDAAoD;EACtE,yDAAqL,EAAE,yBAAyB;EAChN,4BAA4B;EAC5B,sCAAsC,EAAE,6BAA6B;EACrE,qBAAqB,EAAE,4BAA4B;AACrD;;AAEA;EACE,6BAA6B,EAAE,sCAAsC;EACrE,YAAY,EAAE,0BAA0B;EACxC,eAAe,EAAE,kCAAkC;EACnD,YAAY,EAAE,gDAAgD;EAC9D,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;IACX,mBAAmB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,8DAA8D;EAC9D,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB,EAAE,8DAA8D;AAClF;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,gCAAgC;EACzD,mBAAmB,MAAM,8BAA8B;EACvD,sBAAsB,GAAG,oCAAoC;EAC7D,YAAY;AACd;;AAEA;EACE,YAAY,IAAI,wBAAwB;EACxC,aAAa,GAAG,yBAAyB;EACzC,mBAAmB,GAAG,4DAA4D;AACpF;;AAEA;EACE,gBAAgB,EAAE,kDAAkD;EACpE,kBAAkB,EAAE,oBAAoB;AAC1C;;AAEA;EACE,YAAY,kBAAkB,kDAAkD;EAChF,gBAAgB,cAAc,8BAA8B;EAC5D,kBAAkB,YAAY,8BAA8B;EAC5D,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb,kBAAkB;AAClB,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,qCAAqC;AACpD;;AAEA;EACE,YAAY,EAAE,6CAA6C;EAC3D,mBAAmB;EACnB,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,aAAa,EAAE,8BAA8B;EAC7C,uBAAuB,EAAE,iCAAiC;EAC1D,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;;EAEE,kCAAkC;EAClC,eAAe,EAAE,+BAA+B;EAChD,gBAAgB;EAChB,cAAc,EAAE,qBAAqB;EACrC,iBAAiB,EAAE,yCAAyC;EAC5D,SAAS,EAAE,yDAAyD;EACpE,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,4BAA4B,EAAE,yBAAyB;EACvD,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;;AAGA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;;EAErB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,eAAe;IACf,aAAa;IACb,QAAQ,EAAE,iCAAiC;IAC3C,iBAAiB;EACnB;;EAEA;IACE,gCAAgC,EAAE,6BAA6B;EACjE;;EAEA,8CAA8C;EAC9C;IACE,yBAAyB,EAAE,yCAAyC;EACtE;;;;;;EAMA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa,WAAW,oCAAoC;IAC5D,sBAAsB,EAAE,kDAAkD;IAC1E,YAAY,YAAY,uCAAuC;IAC/D,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;EACpB;;AAEF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,yCAAyC;AAC3C","sourcesContent":[".trading-external .main-container-trading {\n  display: flex; /* Flexbox for layout */\n  flex-wrap: wrap; /* Allow content to wrap on smaller screens */\n  width: 100vw; /* Full width of the viewport */\n  box-sizing: border-box; /* Include padding in width calculations */\n  min-height: 100vh; /* Ensure it takes full height of the viewport */\n  margin: 0; /* Remove margin to take full width */\n  background: rgba(32, 35, 66, 1);\n}\n\n.trading-external {\n  background-color: rgb(32, 35, 66);\n  margin-top: -40px;\n  margin-bottom: -5px;\n  height: calc(100% + 45px);\n  width: 100%;\n}\n\n.trading-external .Heading-v {\n  padding: 0 20px;\n  margin-top: 50px;\n}\n\n\n.trading-external .heading {\n  color: white;\n  font-size: 20px;\n  max-height: 10px;\n  font-family: Graphik;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 18.4px;\n  letter-spacing: 0.13803686201572418px;\n  margin-left: 20px;\n}\n\n.trading-external .line-height {\n  border-bottom: 1px solid #7898de;\n}\n\n.trading-external .trading-dropdowns {\n  border-style: solid;\n  border-radius: 10px;\n  /* width: 250px; */\n  font-size: 14px;\n  font-weight: 400;\n  padding-left: 15px;\n  border-width: 1px;\n  background-color: #101222;\n  color: #ffffffde;\n  border: 1px solid #424750;\n  -webkit-appearance: none; /* Remove default dropdown arrow in Webkit browsers */\n  -moz-appearance: none; /* Remove default dropdown arrow in Firefox */\n  appearance: none; /* Remove default dropdown arrow in other browsers */\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 24 24\"><path fill=\"%23ffffff\" d=\"M7 10l5 5 5-5z\"/></svg>'); /* Custom dropdown icon */\n  background-repeat: no-repeat;\n  background-position: right 10px center; /* Position the custom icon */\n  background-size: 30px; /* Size of the custom icon */\n}\n\n.filter-icon-setting {\n  border-style: solid;\n  border-radius: 10px;\n  width: 250px;\n  font-size: 14px;\n  font-weight: 400;\n  padding-left: 15px;\n  padding-right: 30px; /* Space for custom icon */\n  border-width: 1px;\n  background-color: #101222;\n  color: #ffffffde;\n  border: 1px solid #424750;\n  -webkit-appearance: none; /* Remove default dropdown arrow in Webkit browsers */\n  -moz-appearance: none; /* Remove default dropdown arrow in Firefox */\n  appearance: none; /* Remove default dropdown arrow in other browsers */\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 24 24\"><path fill=\"%23ffffff\" d=\"M7 10l5 5 5-5z\"/></svg>'); /* Custom dropdown icon */\n  background-repeat: no-repeat;\n  background-position: right 40px center; /* Position the custom icon */\n  background-size: 30px; /* Size of the custom icon */\n}\n\n.setting-button {\n  background-color: transparent; /* Removes default button background */\n  border: none; /* Removes button border */\n  cursor: pointer; /* Shows pointer cursor on hover */\n  padding: 5px; /* Optional: Adds some padding around the icon */\n  margin-left: -50px;\n  margin-right: 20px;\n}\n.line-section-major {\n  border-bottom: 1px solid #5A596C;\n  margin: 0 20px;\n}\n\n\n.trading-external .dropdown-container {\n  margin: 10px 0;\n  display: flex !important;\n  justify-content: space-between;\n}\n\n.trading-external .dropdown-heading {\n  font-family: Graphik;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  color: #ffffffde;\n  margin: 10px 20px;\n  display: flex;\n    align-items: center;\n}\n\n.trading-external .icons {\n  margin: 0px 15px;\n}\n\n.trading-external .dropdown-container-2 {\n  margin: 15px 20px;\n  display: flex !important;\n  align-items: stretch;\n  height: calc(100vh - 200px);\n}\n\n.trading-external .box1 {\n  height: 49%;\n  border-radius: 10px;\n  background-color: #101222;\n}\n\n.trading-external .sub-box-1 {\n  /* background: #19233880 !important; */\n  /* background: linear-gradient(#19233880 50%) !important; */\n  background-color: rgba(25, 35, 56, 0.5);\n  border-radius: 15px;\n  height: 49%;\n  margin-top: 10px;\n  overflow-y: scroll;\n}\n\n.trading-external .mainbox1 {\n  margin: 10px;\n  width: 30%;\n  /* height: 500px; */\n  border-radius: 15px;\n}\n\n.external-browse-button,\n.trading-external .upload-button-trade {\n  border-radius: 9.111px;\n  border: 0.911px solid #9A60FF;\n  background: #2A2753;\n  box-shadow: 0px 18.221px 36.443px 0px rgba(154, 96, 255, 0.25);\n  display: flex;\n  width: auto;\n  height: 39px;\n  padding: 0px 23.336px 0px 24px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.trading-external .box2 {\n  width: 70%;\n  max-width: 100%;\n  /* height: 500px; */\n  background-color: #101222;\n  margin: 10px auto;\n  border-radius: 10px;\n  color: white;\n  /* padding: 3%; */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  overflow-x: auto; /* Ensures that child elements do not overflow the container */\n}\n\n.trading-external .no-data-show {\n  display: flex;\n  justify-content: center; /* Horizontally center content */\n  align-items: center;     /* Vertically center content */\n  flex-direction: column;  /* Stack image and text vertically */\n  height: 100%;\n}\n\n.trading-external .no-data-show img {\n  width: 340px;   /* Set the image width */\n  height: 200px;  /* Set the image height */\n  object-fit: contain;  /* Keep the aspect ratio of the image, avoiding distortion */\n}\n\n.trading-external .text-inside-no-data {\n  margin-top: 10px; /* Add some space between the image and the text */\n  text-align: center; /* Center the text */\n}\n\n.trading-external .json-box-margin {\n  flex-grow: 1;                 /* Allow the box to grow to fill available space */\n  overflow-y: auto;             /* Enable vertical scrolling */\n  overflow-x: hidden;           /* Hide horizontal scrolling */\n  background-color: #282244;\n  padding: 10px;\n  border-radius: 5px;\n  margin: 2px;\n  max-width: 100%;\n  box-sizing: border-box;\n  max-height: 100%;\n}\n\n.trading-external .browse-files-containers {\n  border: 2px dashed #424750;\n  background-color: #101222;\n  margin-right: 25px;\n  color: white;\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  align-content: center;\n}\n\n.trading-external .Placeholder1 {\n  color: #FFF;\ntext-align: center;\nfont-family: Graphik;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n}\n\n.trading-external .Placeholder2 {\n  color: #A9ACB4;\n  text-align: center;\n  font-family: Graphik;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin: 0;\n  padding: 5px;\n}\n\n.trading-external .Placeholder-3 {\n  font-family: \"Graphik\", sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: white;\n  line-height: 15px;\n} \n\n.trading-external .Placeholder-4 {\n  font-family: \"Graphik\", sans-serif;\n  font-size: 10px;\n  font-weight: 400;\n  color: #a9acb4;\n}\n\n.trading-external .browse-text {\n  margin-top: 5px;\n  text-align: center;\n}\n\n.trading-external .browse-logo {\n  width: 25px;\n  height: 50px;\n}\n\n.regenrate-trading-button {\n  margin: 0px; /* Margin for spacing around button */\n}\n\n.trading-external .upload-button:disabled {\n  opacity: 0.6; /* Set a visible opacity for disabled state */\n  cursor: not-allowed;\n  background-color: #4a4a4a; /* A grey background for disabled state */\n}\n\n.trading-external .upload-button-section {\n  display: flex; /* Use Flexbox for centering */\n  justify-content: center; /* Center the text horizontally */\n  align-items: center; /* Center the text vertically */\n}\n\n.trading-external .upload-btn-label,\n.regenrate-button-label {\n  font-family: \"Graphik\", sans-serif;\n  font-size: 12px; /* Use a consistent font size */\n  font-weight: 500;\n  color: #ffffff; /* White text color */\n  line-height: 1rem; /* Adjusted line-height for readability */\n  margin: 0; /* Removed margins to allow Flexbox to handle centering */\n  text-align: center; /* Ensure text is centered */\n}\n\n.trading-external .template-dropdown {\n  border-radius: 10px;\n  margin: 0px 10px;\n}\n\n.trading-external .tab-spacing {\n  margin: 0 15px 15px;\n}\n\n.trading-external .settingIcon {\n  background-color: #101222;\n  margin: 0px !important;\n  height: 54px;\n  width: 54px;\n  padding: 5px;\n  border-radius: 10px;\n  text-align: center;\n}\n\n\n.templateHeading {\n  width: 90%;\n  height: 50px;\n  color: #ffffff;\n  border-radius: 10px;\n  align-items: center;\n  margin: 15px;\n  align-content: center;\n  background: #2a2753;\n}\n\n.borderType-selected {\n  border: 1px solid #9a60ff !important;\n}\n\n.divSection {\n  /* display:flex; */\n  justify-content: center;\n}\n\n.sectionHeading {\n  color: #ffffffde;\n  margin: 5px ;\n}\n\n.sectionHeading-first {\n  margin: 10px 0px 0px 15px;\n}\n\n.checkBox {\n  color: #9a60ff;\n  margin: 0px 5px;\n}\n\n.displayProperty {\n  margin-right: 5px;\n}\n\n.hideInputBox {\n  display: none;\n}\n\n.flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-top: 15px;\n  overflow-y: scroll;\n  height: 350px;\n}\n\n.flex-item {\n  flex-basis: calc(50% - 30px); /* Two columns with gap */\n  color: #ffffff;\n  background: #2a2753;\n  border-radius: 10px;\n  height: 70px;\n  margin-left: 15px;\n  align-content: center;\n  border: 1px solid #ffffff;\n  overflow-y: scroll;\n}\n\n.add-button {\n  border: 0.75px solid #FFFFFFDE;\n  background: #101222;\n  color: #a9acb4;\n  border-radius: 37px;\n  float: right;\n  width: 68px;\n  font-size: 12px;\n}\n\n.form-inputs {\n  border-radius: 5px;\n  margin-top: 8px;\n  font-size: 14px;\n  font-style: italic;\n  width: 390px;\n  height: 35px;\n}\n\n.form-submit {\n  border-radius: 9px;\n  width: 115px;\n  height: 41px;\n  background: #2A2753;\n  border: 0.91px solid #9A60FF;\n  float: right;\n  margin: 10px 5px;\n  color: #FFFFFF;\n}\n\n.save-cancel-button {\n  border: 0.75px solid #FFFFFFDE;\n  color: #ffffff;\n  float: right;\n  width: 115px;\n  height: 41px;\n  border-radius: 9.69px;\n  background: #2A2753;\n  margin-top: 30px;\n}\n\n.save-button {\n  margin-right: 5%;\n}\n\n.cancel-button {\n  /* background: #A100FF33; */\n  margin-right: 1%;\n  box-shadow: 0px 3px 20px 0px #A100FF33;\n}\n\n.add-icon {\n  width: 10px;\n  height: 10px;\n  margin: 0px 3px 2px 0px;\n}\n\n\n.status-heading {\n  font-size: 16px;\n  border-bottom: 1px solid white;\n}\n\n.status-placeholder {\n  margin-bottom: 0px !important;\n  align-items: flex-start;\n  display: flex;\n}\n\n.loader-box {\n  background-color:  rgba(61, 31, 115, 1);\n}\n\n.loader-block {\n  /* width: 380px; */\n  height: 50px;\n  color: #ffffff;\n  border-radius: 6px;\n  align-items: center;\n  align-content: center;\n  background: rgba(61, 31, 115, 1);\n  padding: 9px;\n}\n\n.heading-trading {\n  padding: 30px 0px 0px 10px !important;\n}\n\n.heading-genai-trading {\n  margin-top: 15px !important;\n}\n\n.icon-text {\n  color: #ffffff;\n  margin: 0px 10px !important;\n  align-content: center;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Graphik\", sans-serif;\n}\n\n.icon-disabled {\n  color: #a9acb4 !important;\n}\n\n\n.file-details {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  padding: 0px 16px;\n  border-radius: 16px;\n  background: #FFFFFF;\n  color: #363636;\n  margin: auto;\n  width: fit-content;\n}\n\n.file-details span {\n  margin-right: 10px;\n  font-family: \"Roboto\";\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14.06px;\n  text-align: center;\n}\n\n.remove-file-button {\n  background: #FFFFFF;\n  border: none;\n  color: #24232B;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.remove-file-button span {\n  display: flex;\n  width: 7.52px;\n  padding: 4px 0px;\n}\n\n.trading-tab {\n  display: flex;\n  justify-content: space-between;\n  align-content: center;\n\n  .left-button-allign {\n    margin-right: 30px;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .tab-container {\n    display: flex;\n    border-bottom: 2px solid #ccc;\n    margin-bottom: 10px;\n  }\n  \n  .tab-button, .active-tab-button {\n    cursor: pointer;\n    background-color: #101222;\n    color: white;\n    border: none;\n    outline: none;\n    transition: background-color 0.3s ease;\n    font-size: 12px;\n    display: flex;\n    gap: 8px; /* Space between image and text */\n    padding-top: 10px;\n  }\n  \n  .active-tab-button {\n    border-bottom: 3px solid #6739B7; /* Highlight the active tab */\n  }\n  \n  /* Optional: Add hover effects for better UX */\n  .tab-button:hover, .active-tab-button:hover {\n    background-color: #1a1c34; /* Slightly lighter background on hover */\n  }\n  \n \n  \n  \n\n  .tab-content {\n    padding: 10px;\n    background-color: #555;\n    color: white;\n    border-radius: 5px;\n    display: flex;          /* Flex layout for the tab content */\n    flex-direction: column; /* Column direction so content stacks vertically */\n    height: 100%;           /* Make it take full available height */\n    max-height: 100%; \n    margin: 0 15px 15px;\n  }\n  \n  .xml-content {\n    white-space: pre-wrap;\n    color: white;\n    background-color: #333;\n    padding: 10px;\n    border-radius: 5px;\n  }\n  \n}\n.trading-external .stop-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 84px;\n  height: 39px;\n  gap: 11px;\n  border-radius: 9px;\n  border: 1px solid #FF6063;\n  cursor: pointer;\n  background-color: #532731;\n  margin: 10px;\n  box-shadow: 0px 12px 16px -16px #022B4940;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
